export const MESSAGE_OF_THE_DAY_ENABLED = 'messageOfTheDay.enabled';
export const MESSAGE_OF_THE_DAY_COOKIE_EXPIRATION_DAYS =
  'web.messageOfTheDay.cookie.exp.days';
export const MESSAGE_OF_THE_DAY_CATEGORY_ID = 'web.messageOfTheDay.categoryId';
export const MESSAGE_OF_THE_DAY_THEME_TYPE = 'web.messageOfTheDay.themeType';
export const MESSAGE_OF_THE_DAY_USE_LEGACY_UI = 'web.messageOfTheDay.legacyUi';
export const MESSAGE_OF_THE_DAY_NAVIGATE_ON_SUBMIT =
  'web.messageOfTheDay.navigateOnSubmit';
